import { AfterContentChecked, Component, OnInit, Renderer2 } from '@angular/core';
import { LineChartSettingsService } from '../line-chart.settings.service';
import { TurnoverService } from '../../../services/turnover.service';

@Component({
  selector: 'app-turnover-chart',
  templateUrl: './turnover-chart.component.html',
  styleUrls: ['./turnover-chart.component.scss']
})
export class TurnoverChartComponent implements OnInit, AfterContentChecked {
  constructor(public turnoverService: TurnoverService, public settings: LineChartSettingsService,
              private renderer: Renderer2,
  ) {
  }

  ngOnInit(): void {
    this.settings = Object.assign({}, this.settings
      .configureYAxisTitle('Turnover Rate (%)')
      .configureYAxisTickFormat((val: number) => `${Math.floor(val * 100.0)}%`)
      .configureYAxisMin(0)
      .configureYAxisMax(1)
      .configureYAxisTickAmount(5)
      .configureTooltip((val: number, opts?: any) => {
        if (val === null || val === undefined) return 'No Data';
        return `${Math.round(val * 100.00 * 10.0) / 10}%`
      }));

    this.turnoverService.resize$.subscribe(() => this.ngAfterContentChecked());

  }

  ngAfterContentChecked() {
    // Hack to move line to be in front of grid border
    // SVG doesn't have a concept of Z-Index and the
    // Line Series is being rendered prior to the grid border
    // Remove when this issue is resolved:
    // https://github.com/apexcharts/apexcharts.js/issues/3599
    const turnoverChart = document.querySelector('div[data-cy=turnover-chart]');
    const childSeries = turnoverChart?.querySelector('.apexcharts-line-series');
    if (childSeries) {
      this.renderer.appendChild(childSeries.parentElement, childSeries);
    }
  }
}
